import * as React from 'react';
import Translation from '../../UI/Translation';

const columns = [
  {
    title: <Translation id='STUDENT_STUDENTIMIE' />,
    dataIndex: 'studentImie',
    key: 'studentImie',
    type: 'text',
    sorter: false,
  },
  {
    title: <Translation id='STUDENT_STUDENTNAZWISKO' />,
    dataIndex: 'studentNazwisko',
    key: 'studentNazwisko',
    type: 'text',
    sorter: false,
  },
  {
    title: <Translation id='STUDENT_STUDENTALBUM' />,
    dataIndex: 'studentAlbum',
    key: 'studentAlbum',
    type: 'text',
    sorter: false,
  },
  {
    title: <Translation id='STUDENT_OCENAWYLICZONA' />,
    dataIndex: 'ocenaWyliczona',
    key: 'ocena',
    type: 'text',
    sorter: false,
  },
];

export default columns;
